import React from 'react';
import MainEntrance from '../components/MainEntrance';

export default function ConsoleGames() {
  const entityType = 'console';

  return (
    <MainEntrance entityType={entityType}/>
  );
}
